import { StyleSheet } from '@react-pdf/renderer'

export const surveyReportPDFStyle = () =>
  StyleSheet.create({
    page: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35
    },
    section: {
      paddingVertical: 15
    },
    center: {
      textAlign: 'center'
    },
    headerTitle: {
      fontSize: 18,
      textAlign: 'center',
      marginBottom: 4,
      fontFamily: 'NotoSans'
    },
    title: {
      fontSize: 24,
      marginBottom: 12,
      textAlign: 'center',
      fontFamily: 'NotoSans',
      color: '#5a570e'
    },
    subtitle: {
      fontSize: 18,
      fontFamily: 'NotoSans',
      fontWeight: 'bold',
      color: '#5a570e',
      margin: 12
    },
    text: {
      paddingHorizontal: 12,
      paddingVertical: 8,
      fontFamily: 'NotoSans',
      fontSize: 12,
      textAlign: 'justify',
      lineHeight: 1.5
    },
    listItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 0,
      marginVertical: 0,
      paddingLeft: 30
    },
    signals: {
      flexDirection: 'column',
      paddingHorizontal: 10,
      marginBottom: 10
    },
    signalsRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      marginBottom: 12
    },
    imageWrapper: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    diagram: {
      marginTop: -40
    },
    smallDiagram: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 150,
      height: 150
    },
    textDiagram_1: {
      position: 'absolute',
      top: 60,
      left: 0,
      width: 150,
      textAlign: 'center',
      color: 'white',
      fontSize: 14,
      fontWeight: 'bold'
    },
    textDiagram_2: {
      position: 'absolute',
      top: 80,
      left: 0,
      width: 150,
      textAlign: 'center',
      color: 'white',
      fontSize: 11
    },
    image: {
      width: 350,
      height: 350,
      marginVertical: 15
      // marginHorizontal: 100
    },
    header: {
      fontSize: 12,
      fontFamily: 'NotoSans',
      marginBottom: 20,
      textAlign: 'center',
      color: 'grey'
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 12,
      fontFamily: 'NotoSans',
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey'
    }
  })
